import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'

export const style = css`
  .delivery-match-delivery-selector {
    --cse-expandable-list-row-gap: var(--csc-delivery-match-method-list-gap, ${csSpacing.spacing05});
  }

  .delivery-match-delivery-selector cse-expandable {
    --cse-expandable-toggle-align: center;
    --cse-expandable-list-incremental-row-gap: var(--csc-delivery-match-method-list-gap, ${csSpacing.spacing05});
  }
`
